import { BodyText, LabelText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";
import logEvent from "src/utils/logEvent";

type TodayResultProps = {
  title: string;
  text?: string;
  fullscreen?: boolean;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class TodayResult extends React.Component<TodayResultProps> {
  componentDidMount() {
    logEvent({
      eventName: "morning.result.open",
    });
  }

  componentWillUnmount() {
    logEvent({
      eventName: "morning.result.close",
    });
  }

  render() {
    const { title, text, fullscreen } = this.props;
    return (
      <article sx={cardStyle(fullscreen)}>
        {title && (
          <LabelText as="h1" sx={titleStyle(fullscreen)}>
            {title}
          </LabelText>
        )}
        <BodyText>{text}</BodyText>
      </article>
    );
  }
}

const cardStyle = (fullscreen?: boolean): ThemeUIStyleObject => ({
  maxWidth: "940px",
  width: fullscreen ? "100vw" : "initial",
  margin: RAW_cssValue("0 auto"),
  padding: RAW_cssValue("12px 12px 42px 12px"),
  textAlign: "left",
  fontSize: !fullscreen ? "20px" : undefined,
  fontWeight: fullscreen ? "800" : "normal",
  whiteSpace: "pre-wrap",
});

const titleStyle = (fullscreen?: boolean): ThemeUIStyleObject => ({
  width: "100%",
  margin: RAW_cssValue("0 auto 22px auto"),
  fontSize: fullscreen ? "64px" : "20px",
  fontWeight: fullscreen ? "800" : "600",
  textAlign: "center",
});
